import React from "react";
import "./styles.css";

const Body = (props) => {
  const product = props.product;
  return (
    <div className="row py-3">
      <div className="col">
        <div className="container">
          <div className="row">
            <div className="col p-0 p-md-2">
              <div className="w-md-75 mx-auto my-md-5 my-3">
                <div className="row">
                  <div className={`contenedor-ficha col-md-6 ${product.hasOwnProperty("essay") ? 'text-right': 'offset-md-3 text-center'}`} id={`contenedor-ficha-${product.slug}`}>
                    <a target="_blank" href={product.technicalFile}>
                      <button type="button" class="btn-outline-green">
                        Ficha de producto
                      </button>
                    </a>
                  </div>
                  {product.hasOwnProperty("essay") && (
                    <div className="col-6 text-left">
                      <a target="_blank" href={`/ensayos/${product.essay}`}>
                        <button type="button" class="btn-outline-green">
                          Ensayos
                        </button>
                      </a>
                    </div>
                  )}
                </div>
                <div className="row mt-5" id="uses">
                  <div className="col text-center">
                  <h3 className="green-light">{product.usesButtonLabel}</h3>

                    {product.uses.map((use) => (
                      <div className="row mb-3 mt-4 my-md-5">
                        <div className="col">
                          <h4 className="green mb-0">{use.title}</h4>
                          <p className="green">{use.description}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="row">
                  <div className="col text-center">
                    <a href="https://tecnomyl.com.ar/contacto" target="_blank">
                      <button type="button" class="btn-green">
                        Contactanos
                      </button>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Body;
